__turbopack_context__.v({
  "cards-wrapper": "EntityListCards-module-scss-module__2PU6ja__cards-wrapper",
});
